// https://github.com/TheNaschkatze/tiptap-extension-font-size/tree/main

import { FontSize } from './font-size'

export * from './font-size'

export default FontSize
